<template>
  <div id="pageTable" class="mainView">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-flex  xs2 sm1>
            <v-select
              :items="['10', '20', '30']"
              name="pageSize"         
              v-model="pageSize"
              label="pageSize"
              @change="banbanCreated()"
            ></v-select>
          </v-flex>
          <v-card>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :items="complex.items"
                class="elevation-1"
                hide-actions
                must-sort
                :pagination.sync="pagination"
                >
                <template slot="items" slot-scope="props">           
                  <td class="text-sm-center">{{ props.item.mid }}</td>
                  <td class="text-sm-center">{{ props.item.type }}</td>
                  <td class="text-sm-center">{{ props.item.sms_count }}</td>
                  <td class="text-sm-center">{{ props.item.fail_count }}</td>
                  <td class="text-sm-center">{{ props.item.msg }}</td>
                  <td class="text-sm-center">{{ props.item.reg_date }}</td>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-text class="text-sm-right">페이지 번호 : {{ pageNum }} </v-card-text>
          </v-card>
          <div style="float:right;">
            <v-btn @click="prevPage()" color="primary">이전</v-btn>
            <v-btn @click="nextPage()" color="primary">다음</v-btn> 
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
const _helpers = require('../../../node_modules/vuetify/es5/util/helpers');
const _slicedToArray = require('../../../mock/sliceToArray');

export default {
  data () {
    return {
      search: '',
      pagination: {
        descending: true,
        rowsPerPage: -1
      },
      next_yn: "N",
      pageNum: 1,
      pageSize: '10',
      complex: {
        headers: [
          {
            text: '메세지 ID',
            value: 'mid',
            align: 'center'
          },
          {
            text: '메세지 타입',
            value: 'type',
            align: 'center'
          },
          {
            text: '성공',
            value: 'sms_count',
            align: 'center'
          },
          {
            text: '실패',
            value: 'fail_count',
            align: 'center'
          },
          {
            text: '메세지 내용',
            value: 'msg',
            align: 'center'
          },
          {
            text: '등록시각',
            value: 'reg_date',
            align: 'center'
          }
        ],
        items: []
      }
    };
  },
  mounted () {
    for (let i = 0; i < this.$parent.$children.length; i++) {
      if (this.$parent.$children[i].chkAutoReload != null) {
        this.$parent.$children[i].chkAutoReload();
      }
    }
    this.banbanCreated();
  },
  methods: {
    banbanCreated () {
      this.complex.items = [];
      const prameters = {
        method: 'SMSList',
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      this.$store.dispatch('banbanAPI', prameters)
        .then(({ data }) => {
          top.getApp.progress.dialog = false;
          this.next_yn = data.next_yn;
          this.complex.items = data.list;
        })
        .catch((error) => {
          if (top.getApp.commonError == null) {
            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
          }
          top.getApp.commonError = null;
          top.getApp.progress.dialog = false;
        });
    },
    prevPage () {
      if (this.pageNum != 1) {
        this.pageNum--;
        this.banbanCreated();
      }
    },
    nextPage () {
      if (this.next_yn == 'Y') {
        this.pageNum++;
        this.banbanCreated();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/sms/SMSList.vue